import React from 'react';
import config from '../../../../config';
import { base64ToHex } from 'util/Utils';
import { Button, Col, Modal, Row } from 'react-bootstrap';
import _ from 'lodash';

export const PrintingScreen = (props) => {
  const { currentServiceRecord = {}, printerChecked, selectedPrinter = {},     CurrentPartnerProductData = {}, } = props.screensData;
  const { UpdatedProductSKUs = [] } = currentServiceRecord;

  return (
    <Row data-testid="screen-content" className="screen-content">
      {config.getEnvironmentName() !== 'production' && printerChecked && (
        <Col xs={6} className="bot10 align-center">
          <div className="purple font-size-21 text-center">
            {selectedPrinter.name ? `Printer ${selectedPrinter.name} connected` : 'Please connect and select a printer'}{' '}
          </div>
        </Col>
      )}
      <Col xs={6} className="top15 align-center text-center">
        <div className="screen_title">{'Please tag with the following barcode'}</div>
        <div className="font-size-25 text-bold top30 bot30 pbot30 ptop30">{formatSKU(props.displayProductSKUs(), props.appData.FeatureFlags)} </div>
      </Col>

      <Col xs={6} className="align-center text-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="101"
          height="101"
          ref={(barcodeSVG) => {
            props.setBarcodeSVG(barcodeSVG);
          }}
          id="barcodeSVG"
        ></svg>

        <div className="top20">
          {printerChecked && (
            <div className="top20">
              <Button
                data-testid="print-barcode-button"
                className="btn btn-lg btn-primary set-width "
                disabled={!selectedPrinter.name}
                onClick={() => {
                  if (props.appData.FeatureFlags.WarehouseLocationScreenDisabled && !CurrentPartnerProductData._id) {
                    props.updateParentComponentState({ showModal: true });
                  }
                  printBarcode(props);
                }}
              >
                {`Print ${UpdatedProductSKUs.length > 1 ? 'Barcodes' : 'Barcode'}`}
              </Button>
            </div>
          )}
          <div className="top20">
            .
            <Button
              data-testid="check-another-product-button"
              className="btn btn-lg btn-primary set-width "
              disabled={props.appData.FeatureFlags.DoNotSkipPrintingBarcode && !props.screensData.barcodePrinted}
              onClick={() => {
                props.resetScreensData();
              }}
            >
              Check-in another product
            </Button>
          </div>
          {printerChecked && (
            <Button
              data-testid="connect-to-printer-button"
              className="top20 btn btn-lg btn-primary set-width "
              onClick={() => {
                BrowserPrint.getLocalDevices(
                  (deviceListData) => {
                    console.log('deviceListData', deviceListData);
                    props.setScreensData({ selectedPrinter: _.get(deviceListData, ['printer', 0]) });
                  },
                  (errorMessage) => {
                    props.displayMessage({
                      messageType: 'warning',
                      messageCode: 'Can not get data for the printer ' + errorMessage,
                    });
                  }
                );
              }}
            >
              {selectedPrinter.name ? 'Re-connect to printer' : 'Connect to printer'}
            </Button>
          )}
        </div>
      </Col>
      <Modal
        data-testid="pictures-ready-modal"
        onExited={(e) => props.updateParentComponentState({ showModal: false })}
        show={props.showModal}
        onHide={(e) => props.updateParentComponentState({ showModal: false })}
      >
        <Modal.Header style={{ borderBottomWidth: 0 }} closeButton>
          <Modal.Title style={{ marginTop:45, marginBottom:45  }}className="text-center font-size-22">{'Ready for pictures!'}</Modal.Title>
        </Modal.Header>

      </Modal>
    </Row>
  );
};

const formatSKU = (sku, featureFlags) => {
    if (featureFlags.BarcodePrintOnlyThreeDigits) {
      sku = (sku || "").match(/^(\d+\.\d+\.\d+)/) || [sku]
      return sku[0]
    } else {
      return sku
    }
}

const printBarcode = (props) => {
  if (props.pending) {
    return;
  }
  props.updateParentComponentState({ pending: true });
  const {
    ProductID,
    currentServiceRecord = {},
    nextProductNumber = '',
    CurrentPartnerProductData = {},
  } = props.screensData;
  let params = {
    ProductID: ProductID,
  };
  const { UpdatedProductSKUs = [], SellerID = {} } = currentServiceRecord;

  if (UpdatedProductSKUs.length) {
    params.barcodesToGenerate = UpdatedProductSKUs;
  } else {
    /* when posting new listing */
    params.barcodesToGenerate = [
      `${SellerID.SellerNumber}.${currentServiceRecord.SellerPickupNumber}.${nextProductNumber}`,
    ];
  }

  if (CurrentPartnerProductData._id) {
    params.ProductID = base64ToHex(CurrentPartnerProductData._id);
  }
  props.generateBarcodes(params);
};
